import React from 'react';
import { motion } from 'framer-motion';
import { ParticleBackground } from './ParticleBackground';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Smartphone, Zap } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full bg-dark-bg overflow-hidden flex flex-col justify-center items-center py-20 px-4" data-id="element-108">
      <ParticleBackground data-id="element-109" />

      {/* Floating Orbs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-violet-600/20 rounded-full blur-[100px] animate-orb-float pointer-events-none" data-id="element-110" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-indigo-600/10 rounded-full blur-[120px] animate-orb-float pointer-events-none" style={{
      animationDelay: '2s'
    }} data-id="element-111" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-112">
        {/* Top Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 bg-violet-900/30 border border-violet-500/30 rounded-full px-4 py-1.5 mb-8 backdrop-blur-sm" data-id="element-113">
          <span className="text-violet-300 text-sm font-medium tracking-wide" data-id="element-114">
            🔮 Oferta Especial por Tiempo Limitado
          </span>
        </motion.div>

        {/* Headlines */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-display text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-4 leading-tight" data-id="element-115">
          Reiki MegaPack
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-3xl md:text-4xl font-display font-bold gradient-text-violet mb-6" data-id="element-116">
          Nivel 1, 2 y Maestría
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-lg md:text-xl text-violet-light/90 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-117">
          Todo lo que necesitás para convertirte en Maestro de Reiki desde la
          comodidad de tu hogar
        </motion.p>

        {/* Product Hero Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="relative w-full max-w-sm md:max-w-md mb-12 group" data-id="element-118">
          <div className="absolute inset-0 bg-gradient-to-tr from-violet-600 to-indigo-600 rounded-xl blur-2xl opacity-40 group-hover:opacity-60 transition-opacity duration-500" data-id="element-119" />

          <a href="https://pay.hotmart.com/O103704589E" target="_blank" rel="noopener noreferrer" onClick={() => {
          if ((window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout', {
              content_name: 'Reiki MegaPack',
              content_category: 'Curso Online',
              value: 19990,
              currency: 'CLP'
            });
          }
        }} className="block relative z-10 transform transition-transform duration-500 hover:scale-[1.02]" data-id="element-120">
            <img src="https://cdn.magicpatterns.com/uploads/xqLnkAJfrP3F7JMjsc4BwN/ChatGPT_Image_5_feb_2026,_16_11_23.png" alt="MegaPack Camino Integral del Reiki - Formación Completa" className="w-full h-auto rounded-xl shadow-2xl border border-violet-500/30" data-id="element-121" />
          </a>
        </motion.div>

        {/* CTA Area */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1
      }} className="flex flex-col items-center gap-6 w-full" data-id="element-122">
          <CTAButton text="¡QUIERO MI MEGAPACK AHORA!" size="xl" data-id="element-123" />

          <p className="text-sm text-gray-400 flex flex-wrap justify-center gap-4" data-id="element-124">
            <span className="flex items-center gap-1" data-id="element-125">
              <Zap className="w-4 h-4 text-yellow-400" data-id="element-126" /> Acceso inmediato
            </span>
            <span className="hidden md:inline text-gray-600" data-id="element-127">•</span>
            <span className="flex items-center gap-1" data-id="element-128">
              <Smartphone className="w-4 h-4 text-blue-400" data-id="element-129" /> Compatible con
              todos los dispositivos
            </span>
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-6 mt-4" data-id="element-130">
            <span className="flex items-center gap-1.5 text-xs md:text-sm text-gray-300 bg-white/5 px-3 py-1.5 rounded-full border border-white/10" data-id="element-131">
              <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-132" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1.5 text-xs md:text-sm text-gray-300 bg-white/5 px-3 py-1.5 rounded-full border border-white/10" data-id="element-133">
              <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-134" /> Acceso de por
              vida
            </span>
            <span className="flex items-center gap-1.5 text-xs md:text-sm text-gray-300 bg-white/5 px-3 py-1.5 rounded-full border border-white/10" data-id="element-135">
              <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-136" /> Garantía 7 días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}